// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609171836/js/" + chunkId + "." + {"44":"8351f945","225":"783a4f8f","481":"165374b6","486":"55453e20","770":"1bac0854"}[chunkId] + ".0.2337872174662451.chunk.js";
};